import { ApiError } from '../services/whatsappApi';
import type { MessageType } from '../types/whatsapp';

// Opening an attachment of the thread (flow 7). The file is fetched when the person asks for it.

export const MEDIA_ERROR_TEXT = 'No se pudo abrir el archivo. Intenta de nuevo.';

export type AttachmentKind = 'image' | 'video' | 'audio' | 'document';

/** How an attachment is opened: images and videos in the viewer, audio in place, documents as a download. */
export const attachmentKind = (type: MessageType): AttachmentKind | null => {
  switch (type) {
    case 'image':
    case 'sticker':
      return 'image';
    case 'video':
      return 'video';
    case 'audio':
      return 'audio';
    case 'document':
      return 'document';
    default:
      return null;
  }
};

export type MediaFailure = { kind: 'expired' } | { kind: 'error'; text: string };

/** 410 `media_expired`: Meta no longer has the file. Anything else is worth trying again. */
export const mediaFailure = (err: unknown): MediaFailure =>
  err instanceof ApiError && (err.status === 410 || err.code === 'media_expired')
    ? { kind: 'expired' }
    : { kind: 'error', text: MEDIA_ERROR_TEXT };

/** Name offered when the file is saved. */
export const downloadName = (filename: string | undefined, id: number): string =>
  filename && filename.trim() !== '' ? filename : `archivo-${id}`;
